import { FC } from "react";

import { AvgMaterialCompositionSmallHomeAppliancesTooltipProps } from "./AvgMaterialCompositionSmallHomeAppliancesTooltip.type";

const AvgMaterialCompositionSmallHomeAppliancesTooltip: FC<AvgMaterialCompositionSmallHomeAppliancesTooltipProps> = (props) => {
	const { active, payload } = props;

	if (!active || !payload || !payload.length) {
		return null;
	}

	const data = payload[0] && payload[0].payload;

	return (
		<div className="p-3 m-0 bg-white border border-primary">
			<p className="text-xs">
				{`${props.material}: ${new Intl.NumberFormat("nl-BE").format(data.value)} (${data.category})`}
			</p>
		</div>
	);
};

export { AvgMaterialCompositionSmallHomeAppliancesTooltip };
